<template>
  <div
    v-if="hasContent && !hasError"
    class="ContentBlockContainer"
  >
    <div
      v-for="(item, idx) in contentBlockComponents"
      :key="idx"
      class="contentblock-wrapper"
    >
      <component
        :is="item.component"
        :id="item.id"
        class="contentblock-item"
        :class="item.classes"
        :content="item.contentblock.content"
        :settings="item.contentblock.instellingen"
        :contentblock-idx="idx"
        :bread-crumb="breadCrumb"
        :main-event-id="mainEventId"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'
  import type { ContentBlock } from '../types/contentblocks'

  const props = defineProps<{
    page: ElocusPage
    contentblocks: ContentBlock[]
    breadCrumb?: BreadCrumb[]
    mainEventId?: string | number
  }>()

  const { contentBlockComponents, hasContent, hasError } = useContentBlockContainer(props.contentblocks)
</script>

<style lang="scss">
  .ContentBlockContainer {
    display: flex;
    align-items: center;
    flex-direction: column;

    .contentblock-wrapper {
      width: 100%;
    }

    .contentblock-item {
      position: relative;
      width: 100%;
      padding-bottom: $contentblock-margin;
      padding-top: $contentblock-margin;

      &:deep(.content-title) {
        margin-bottom: var(--margin-lg);
      }

      &.no-overflow-x {
        overflow: inherit;
      }

      &.double-margin-top {
        padding-top: calc($contentblock-margin * 2);
      }

      &.double-margin-bottom {
        padding-bottom: calc($contentblock-margin * 2);
      }

      &.half-margin-bottom {
        padding-bottom: calc($contentblock-margin / 2);
      }

      &.half-margin-top {
        padding-top: calc($contentblock-margin / 2);
      }

      &.no-margin-bottom {
        padding-bottom: 0;
      }

      &.no-margin-top {
        padding-top: 0;
      }
    }

    .error {
      color: red;
    }
  }
</style>
